export const ImagesUrl = 'https://cdn.ciss.fr/images/myterminal/'

export const AlertImages = {
  error: require('@/assets/img/alert/error.png'),
  info: require('@/assets/img/alert/info.png'),
  success: require('@/assets/img/alert/success.png'),
  warning: require('@/assets/img/alert/warning.png'),
  warningred: require('@/assets/img/alert/warning-red.png')
}

export const LogoImages = {
  cashless: require('@/assets/img/logo/cashless.png'),
  catering: require('@/assets/img/logo/catering.png'),
  cb: require('@/assets/img/logo/cb.png'),
  cheque: require('@/assets/img/logo/cheque.png'),
  ecocup: require('@/assets/img/logo/ecocup.png'),
  especes: require('@/assets/img/logo/especes.png'),
  gift: require('@/assets/img/logo/gift.png'),
  giftcard: require('@/assets/img/logo/giftcard.png'),
  giftchq: require('@/assets/img/logo/giftchq.png'),
  loyalty: require('@/assets/img/logo/loyalty.png'),
  lydia: require('@/assets/img/logo/lydia.png'),
  lyfpay: require('@/assets/img/logo/lyfpay.png'),
  mobil: require('@/assets/img/logo/mobil.png'),
  offert: require('@/assets/img/logo/offert.png'),
  vivawallet: require('@/assets/img/logo/vivawallet.png'),
  tips: require('@/assets/img/logo/tips-icon.jpg'),
  dpa: require('@/assets/img/logo/dpa.svg')
}

export const PartnerImages = {
  metropoleRouenNormandie: require('@/assets/img/partner/metropole-rouen-normandie.png'),
  reseauAstuce: require('@/assets/img/partner/reseau-astuce.png')
}

export const AppImages = {
  logo: require('@/assets/logo.png'),
  nfcWave: require('@/assets/wave.gif'),
  lock: require('@/assets/lock-keyhole.svg'),
  lockNfc: require('@/assets/Icon_nfc-card-hand.png'),
  qrMan: require('@/assets/barcode.png'),
  swipe: require('@/assets/img/swipe.png'),
  alphaXBox: require('@/assets/img/alpha-x-box.svg'),
  alphaZBox: require('@/assets/img/alpha-z-box.svg'),
  nfcRound: require('@/assets/img/nfc-round.svg'),
  noImage: require('@/assets/img/no-image.png'),
  pictoCroix: require('@/assets/img/picto_croix.png'),
  pictoInferieur: require('@/assets/img/picto_inferieur.png'),
  pictoRond: require('@/assets/img/picto_rond.png')
}

export const CDNImages = {
  secoursPopulaire: ImagesUrl + 'secours_populaire_logo.svg'
}
